<div class="page-container">
  <section class="hero-section">
    <div class="hero-content">
      <div class="logos">
        <img style="margin-left:3%" src="../../../assets/icons/PearonEvolutionLogo.png" alt="Pearson logo">
        <span class="vertical-divider">|</span>
        <img src="../../../assets/icons/Microsoft.svg" alt="Microsoft logo">
      </div>
      <p class="hero-headline">MCTs are an elite group of professionals shaping the future of tech.</p>
      <p class="hero-description">
        Enjoy exclusive benefits, boost your professional credibility, and share your expertise with the world.
        Access the Portal to sign in, register, or renew your membership.
      </p>
      <div class="hero-buttons">
        <a class="btn-learn-more" role="button" tabindex="0" (click)="scrollToDiscoverSection()" (keydown.enter)="scrollToDiscoverSection()"
          (keydown.space)="scrollToDiscoverSection(); $event.preventDefault()">Become an MCT</a>
        <a class="btn-explore" role="button" tabindex="0" (click)="onLearnMore()" (keydown.enter)="onLearnMore()"
          (keydown.space)="onLearnMore(); $event.preventDefault()">Learn more</a>
      </div>

    </div>
     <div class="hero-badge">
      <img src="../../../assets/images/badge.png" alt="Microsoft Certified Trainer logo">
    </div>
  </section>

  <section class="cards-container">
    <div class="card" *ngFor="let card of featureCards;">
      <div class="card-icon-side">
        <img [src]="card.icon" [alt]="card.category">
      </div>
      <div class="card-text-side">
        <span class="category">{{ card.category }}</span>
        <h2 style="font-weight:600" tabindex="0" [attr.aria-label]="card.title"> {{ card.title }} </h2>
        <p> {{ card.text }}</p>
        <a (click)="card.link()" target="_blank" rel="noopener noreferrer" [attr.aria-label]="card.linkText">{{
          card.linkText }}</a>
      </div>
    </div>
  </section>

  <div id="discoverPathSection" class="discover-container">
    <div class="content-wrapper">
      <h2 style="font-weight:600" class="title">Discover your path</h2>
      <p>Upon attainment of your <a href="https://learn.microsoft.com/en-us/credentials/certifications/ai-business-professional/?practice-assessment-type=certification" class="mct-link" target="_blank">AB-730</a> or <a href="https://learn.microsoft.com/en-us/credentials/certifications/ai-transformation-leader/?practice-assessment-type=certification" class="mct-link" target="_blank">AB-731</a> certification, you can join the MCT program through one of the following pathways:</p>
      
      <div class="table-container mat-elevation-z1">
        <table mat-table [dataSource]="dataSource">

          <!-- FIX 1: Convert td to th with scope="row" for proper Row Headers -->
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef scope="col"> I am... </th>
            <th mat-cell *matCellDef="let element" scope="row" role="rowheader"> {{element.role}} </th>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef scope="col"> To become an MCT, I will... </th>
            <td mat-cell *matCellDef="let element" class="sanitized-action-cell" innerHTML="{{element.action}}"> </td>
          </ng-container>

          <!-- FIX 2: Added attr.aria-label as an extra safety measure alongside sr-only -->
          <ng-container matColumnDef="getStarted">
            <th mat-header-cell *matHeaderCellDef scope="col"> Next Steps </th>
            <td mat-cell *matCellDef="let element">
              <a [href]="element.linkUrl" 
                 [routerLink]="['/find-your-fee']" 
                 [queryParams]="{ tab: element.targetTab }" 
                 [attr.aria-label]="element.ariaLabel"
                 class="action-link">
                 <span aria-hidden="true">{{element.linkText}}</span>
                 <span class="sr-only">{{element.ariaLabel}}</span>
              </a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <p style="font-size: 12px;color:#333;margin-top:8px">*Please note: AB-730 or AB-731 serve as pre-requisites to the pathways above. You will not be eligible for enrollment in the MCT program without one of these certifications.</p>
    </div>
  </div>

  <section class="icons-section">
    <div class="container icon-grid">
      <div class="icon-card" *ngFor="let icon of icons1">
        <div class="icon-wrapper">
          <fa-icon style="color:#fff;margin-left:7.9%" [icon]="icon.icon" aria-hidden="true"></fa-icon>
        </div>
        <h3>{{ icon.title }}</h3>
        <p>{{ icon.text }}</p>
      </div>
    </div>
  </section>
</div>